import { useOpMutation } from '../useOpMutation';

export const useUpdateUserPreferenceSet = ({ ...useOpMutationOptions } = {}) =>
  useOpMutation({
    apiEndpointName: 'updateUserPreferenceSet',
    onSuccessMessage: 'Successfully updated user preferences',
    queryKeysToInvalidate: [['describeUserPreferenceSet']],
    ...useOpMutationOptions,
  });
